import { render } from "./HelloWorld.vue?vue&type=template&id=85d5a9a6&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=85d5a9a6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-85d5a9a6"

export default script